module.exports = __webpack_public_path__ + "img/拨打电话.bb258952.png";